import {Component, OnInit } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { isMobile } from "@core/utility.service";
import { IonicModule, NavParams, PopoverController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs/operators";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { WindowsGamePlayPopupComponent } from "src/app/components/windows-game-play-popup/windows-game-play-popup.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { GameStreamsService } from "../services/game-streams.service";
import { GameDatasService } from "../services/game-data.service";
import { GamePlayBaseComponent } from "../shared/game-play-base.component";
@Component({
    selector: "app-yours-to-play-popup",
    templateUrl: "./yours-to-play-popup.component.html",
    styleUrls: ["./yours-to-play-popup.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [
        IonicModule,
        MatProgressSpinner,
        MatIcon,
        TranslatePipe,
    ],
})
export class GamePreDetailsPopupComponent extends GamePlayBaseComponent implements OnInit {
  gameDetails: any;
  gametooltip$;
  gameInfo$: any;
  prizeUnlockID: any;
  public popupDetails: string;
  
  public languageCode: string;
  constructor(
    private popoverController: PopoverController,
    private navParams: NavParams,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    private gameStreamsService: GameStreamsService,
    private gameDatasService: GameDatasService,
  ) {
    super()
  }

  ngOnInit() {
    super.ngOnInit()
    try {
      this.gameDetails = this.navParams?.data?.data;
      if (this.gameDetails && this.gameDetails?.int_game_popup_details) {
        this.authService
          .getDVFromString(this.gameDetails?.int_game_popup_details[this.languageCode])
          .then((resp: string) => {
            this.popupDetails = resp;
          }).catch((err) => {
            return err;
          });
      } else {
        const one = 1;
        const therr = 353;
        const defaultCurrency = 44;
        const cc = this.gameDetails?.cc ? this.gameDetails?.cc : defaultCurrency;
        const gamePopupDetails = this.preferredCurrency == 'CAD' ?
          this.gameDetails?.country_code_data[one]?.game_popup_details :
          this.preferredCurrency == 'EUR' ? this.gameDetails?.country_code_data[therr]?.game_popup_details
            : this.gameDetails?.country_code_data[cc]?.game_popup_details;
        this.authService
          .getDVFromString(gamePopupDetails)
          .then((resp: string) => {
            this.popupDetails = resp;
          }).catch((err) => {
            return err;
          });
      }


      this.gameStreamsService.prizeUnlock$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.prizeUnlockID = data;
        if (this.prizeUnlockID == this.gameDetails.game_id) {
          this.gameInfo$ = this.gameDatasService
            .getGameInfoY2P(this.gameDetails.game_id, "yours_to_play")
            .subscribe((data) => {
              this.gameInfo$ = data;
            });
        }
      });
    } catch (e) { }
  }

  async playGame(gameDetails) {
    this.GTMSegment.HotJarEvent('user_played_game');
    if (!gameDetails) return null;
    try {
      if (!isMobile.any() && gameDetails && gameDetails.orientation == "landscape") {
        this.popoverController.dismiss();
        this.dialog.open(WindowsGamePlayPopupComponent);
        return null;
      }
    } catch (e) { }
    let isUpdatedCelebration;
    try {
      gameDetails.document = "/api_post_request/customer_game_token_authentication";
      gameDetails.from_page = "yours-to-play-popup";
      this.playGameBase(gameDetails)
    } catch (Error) {
      this.isPlayInProgress = false;
      /* const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
      this.authService.showToast(msg ? msg : "Something went wrong", "error", ""); */
      this.authService.getConstantsMsg("1014").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Something went wrong",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        }
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((error) => {
        return error;
      });
    }
  }


  async viewDetails() {
    try {
      await this.popoverController.dismiss(this.gameDetails).catch((err) => {
        return err;
      });
    } catch (e) { }
  }

}
